import axios from "axios";


function __uploadAddToList(list, id, name) {
    let item = document.createElement('div');
    item.className = 'form-uploaded-file';
    item.setAttribute('data-file', id);

    item.innerHTML = `
        <div class="uploaded-file-progressbar"></div>
        <div class="uploaded-file-icon"></div>
        <span class="uploaded-file-name">${name}</span>
        <div class="uploaded-file-progress">0%</div>
        <button class="button button--transparent button--small button--remove-file">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
        </button>
    `;

    list.appendChild(item);
}

function __uploadPrepareForProgress(list, id) {
    let item = list.querySelector('[data-file="' + id +'"]');
    if (item) {
        item.classList.add('form-uploaded-file--uploading');
    }
}

function __uploadSetProgress(list, id, percentage) {

    let item = list.querySelector('[data-file="' + id +'"]');
    if (item) {
        let bar = item.querySelector('.uploaded-file-progressbar');
        let text = item.querySelector('.uploaded-file-progress');

        bar.style.width = percentage + '%';
        text.innerText = Math.floor(percentage) + '%';
    }

}

function __uploadDoneFor(list, id, data) {
    let item = list.querySelector('[data-file="' + id +'"]');
    if (item) {
        item.classList.remove('form-uploaded-file--uploading');
        let icon = item.querySelector('.uploaded-file-icon');
        icon.classList.add('uploaded-file-icon--' + data.extension.toLowerCase());
        item.setAttribute('data-hash', data.hash)
    }
}

function __uploadErrorFor(list, id, message) {
    message = message || false;

    let item = list.querySelector('[data-file="' + id +'"]');
    if (item) {
        if (message) {
            item.querySelector('.uploaded-file-name').innerText = message;
        }
        item.classList.remove('form-uploaded-file--uploading');
        item.classList.add('form-uploaded-file--error');

        setTimeout(function() {
            item.remove();
            __uploadSetValuesFor(list);
        }, 7500);
    }
}

function __uploadSetValuesFor(list) {

    let input = list.closest('[data-key]');
    let key = input.getAttribute('data-key');

    let value = input.querySelector('[name="'+ key +'"]');
    let files = Array.from(list.querySelectorAll('[data-hash]'));
    value.value = files.map(_ => _.getAttribute('data-hash')).join(',');

    let button = input.querySelector('.button--add-file');
    let maxFiles = 1;
    if (files.length >= maxFiles) {
        button.style.display = 'none';
    } else {
        button.style.display = 'inline-flex';
    }


}

function __uploadFile (data, progress_callback, success_callback, fail_callback, done_callback, random_id) {
    progress_callback = progress_callback || false;
    success_callback = success_callback || false;
    fail_callback = fail_callback || false;
    random_id = random_id || false;

    var config = {
        onUploadProgress: function(progressEvent) {
          let percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );

          if (progress_callback) {
              progress_callback(percentCompleted, random_id);
          }

        }
      };


    axios.post('/admin/file', data, config)
    .then(function (res) {
        
        if (success_callback) {
            success_callback(res.data, random_id);
        }
        
    })
    .catch(function (err) {
        if (fail_callback) {
            fail_callback(err.response.data && err.response.data.message ? err.response.data.message : err.message, random_id);
        }
    })
    .then(function() {
        if (done_callback) {
            done_callback();
        }
    });

}

Array.from(document.querySelectorAll('.button--add-file')).forEach(function(button) {

    let parent = button.closest('.form-input');
    let input = parent.querySelector('[type=file]');
    let file_list_element = parent.querySelector('.form-uploaded-files');
    

    button.onclick = function() {

        input.click();

        return false;
    }

    input.onchange = function(event) {
        const [file] = input.files
        if (file) {
            
            let random_id = 'file_' + (new Date()).getTime() + '_' + Math.floor(1000000000 + Math.random() * 99999999999);

            if (file.size > 10000000) {
                __uploadAddToList(file_list_element, random_id, '');
                __uploadErrorFor(file_list_element, random_id, "Yüklemeye çalıştığınız dosya 10Mb\'dan küçük olmalı.");
                return false;
            }

            let data = new FormData();
            data.append('file', file);

            __uploadAddToList(file_list_element, random_id, file.name);
            __uploadPrepareForProgress(file_list_element, random_id);

            button.style.display = 'none';
            __uploadFile(data,
                function(percentage) {
                    console.log("progress");
                    console.log(percentage);
                    __uploadSetProgress(file_list_element, random_id ,percentage)
                },

                function(data) {
                    console.log("Ok");
                    console.log(data);
                    __uploadDoneFor(file_list_element, random_id, data.data);
                },

                function(message) {
                    console.log("err");
                    console.log(message);
                    __uploadErrorFor(file_list_element, random_id, message);
                },
                function() {
                    __uploadSetValuesFor(file_list_element);
                },
                random_id
            );
          
            
            input.value = '';

        }
    }

    file_list_element.onclick = function(event) {

        let target = event.srcTarget || event.target;

        let removeButton = target.closest('.button--remove-file');
        if (removeButton) {
            let file = removeButton.closest('[data-file]');
            file.remove();

            __uploadSetValuesFor(file_list_element);
        }

    }

    

});